import { render } from "./ElectricityCost.vue?vue&type=template&id=540ff2fb&scoped=true"
import script from "./ElectricityCost.vue?vue&type=script&lang=js"
export * from "./ElectricityCost.vue?vue&type=script&lang=js"

import "./ElectricityCost.vue?vue&type=style&index=0&id=540ff2fb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-540ff2fb"]])

export default __exports__